import { createComponent } from '@carvana/merch-components';
import { CommonModuleInner } from '../styles';

export const ModuleInner = createComponent(CommonModuleInner, {
  className: ' m:flex-row m:gap-80'
});

export const Link = createComponent('a', {
  className: `
    flex
    items-center
    justify-between
    gap-16
    border-b
    border-grey-2
    py-20
    text-blue-6
    tl-body-m
    first:pt-24
    last:border-b-0
    last:pb-24
    hover:text-blue-3
    hover:underline
  `
});
